import {faSliders} from "@fortawesome/pro-solid-svg-icons/faSliders";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ColourSolid} from "@twigsby/frontend-framework";
import React from "react";
import AccountOverview from "../Pages/User/AccountOverview";
import AddRuleset from "../Pages/AddRuleset";
import Rulesets from "../Pages/Rulesets";
import {AccountRoutes} from "./Account/AccountRoutes";
import {PaymentRoutes} from "./Account/PaymentRoutes";
import {ReferralRoutes} from "./Account/ReferralRoutes";
import {SecurityRoutes} from "./Account/SecurityRoutes";
import {SiteSettingsRoutes} from "./Account/SiteSettingsRoutes";
import {YourPlanRoutes} from "./Account/YourPlanRoutes";
import {SuggestibleRouteInterface} from "./TopRoutes";

const ManageAccountRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Manage User',
        path: '/manage-account',
        icon: faSliders,
        element: <AccountOverview />,
        colour: ColourSolid.Success,
        children: [
            ...YourPlanRoutes,
/*            ...YourDetailsRoutes,*/
            ...PaymentRoutes,
            ...AccountRoutes,
            ...SecurityRoutes,
            ...SiteSettingsRoutes,
            ...ReferralRoutes,
            {
                title: 'Rulesets',
                path: '/manage-account/rulesets',
                element: <Rulesets />
            },
            {
                title: 'Add Ruleset',
                path: '/manage-account/rulesets/add',
                element: <AddRuleset />
            },
        ]
    },
]

export { ManageAccountRoutes }
